import metricsService from "./MetricsService";

export const sendMetrics = (
  streamId: string,
  payload: Record<string, string | number | Record<string, string | number>>,
) => {
  return metricsService.post({ path: `client/metrics/${streamId}`, body: payload });
};
